import { Input } from '@/components/Input';
import {
    selectPaidAmount,
    selectPaidFrequency,
    setPaidAmount,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { getFrequencyLabel } from '@/utils/getFrequencyLabel';
import { getNumber } from '@/utils/valueFormat';

export interface IAmountPaid {
    baseId: string;
    showErrors: boolean;
}

export function AmountPaid({ baseId, showErrors }: IAmountPaid): JSX.Element {
    // ***** Redux *****
    const amountPaid = useAppSelector(selectPaidAmount);
    const paidFrequency = useAppSelector(selectPaidFrequency);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        if (typeof value === 'boolean') return;
        // MAXIMUM
        const MAXIMUM = 99999;
        const intValue = getNumber(value, MAXIMUM);
        if (intValue === amountPaid) return;
        dispatch(setPaidAmount(intValue));
    }

    // ***** Render *****
    const frequencyLabel = getFrequencyLabel(paidFrequency);
    return (
        <div data-testid='AmountPaid'>
            <Input
                title={
                    frequencyLabel
                        ? `Amount paid into your bank account (${frequencyLabel.toLowerCase()})`
                        : 'Amount paid into your bank account'
                }
                placeholder='4,250'
                showErrors={showErrors && !amountPaid}
                onChange={handleChange}
                id={`${baseId}-input-amountPaid`}
                value={amountPaid?.toLocaleString()}
                prefix='$'
                showNumpad={true}
                tooltipContent="Cash-in-hand income can't be counted, so enter only what's paid into your account."
            />
        </div>
    );
}
